import { create } from 'zustand';
import { supabase } from '../lib/supabase';
import { ServiceCategory } from '../types/service';

interface ServiceCategoryStoreState {
  serviceCategories: ServiceCategory[];
  loading: boolean;
  hasSettledServiceCategoriesLoad: boolean;
  fetchServiceCategories: () => Promise<ServiceCategory[]>;
  upsertServiceCategory: (serviceCategory: ServiceCategory) => void;
}

export const useServiceCategoryStore = create<ServiceCategoryStoreState>((set, get) => ({
  serviceCategories: [],
  loading: false,
  hasSettledServiceCategoriesLoad: false,
  upsertServiceCategory: serviceCategory => {
    set(state => {
      const existingIndex = state.serviceCategories.findIndex(
        item => item.id === serviceCategory.id
      );
      if (existingIndex === -1) {
        return {
          serviceCategories: [...state.serviceCategories, serviceCategory].sort((a, b) =>
            a.label.localeCompare(b.label)
          ),
        };
      }

      return {
        serviceCategories: state.serviceCategories.map(item =>
          item.id === serviceCategory.id ? serviceCategory : item
        ),
      };
    });
  },
  fetchServiceCategories: async () => {
    try {
      if (get().loading) return get().serviceCategories;

      set({ loading: true });
      const { data, error } = await supabase
        .from('service_categories')
        .select('id, slug, label, label_fr, label_en')
        .order('label', { ascending: true });
      set({ serviceCategories: (data as ServiceCategory[]) || [], loading: false });
      set({ loading: false });

      if (error) throw error;

      return data || [];
    } finally {
      set({ loading: false, hasSettledServiceCategoriesLoad: true });
    }
  },
}));
